<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <v-sheet class="neu-glow with-radius" max-width="500">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12 px-6 pos-relative" >
                  <div class="my-6 text-center ">
                    <div class="text-h4 d-flex justify-center align-center">
                      <v-img
                          src="/static/fs/symbol-logo_fs_sinfondo.png"
                          lazy-src="/static/fs/symbol-logo_fs_sinfondo.png"
                          alt="Logo Futurespace"
                          max-width="50px"
                      ></v-img>
                      <span class="ml-3"><h4 class="primary--text">{{ $t('Global.Main.appName') }}</h4></span>
                    </div>
                    <div class="text-subtitle-1">{{ stepsDetails.title }}</div>
                    <div class="text-body-2">{{ stepsDetails.subtitle }}</div>
                  </div>
                  <v-sheet max-width="380" height="300" class="mx-auto" color="transparent">
                    <send-otp
                        @next="completeProcess"
                    />
                    <v-btn
                        icon
                        absolute
                        top
                        right
                        to="/site/admin"
                    >
                      <v-icon small>close</v-icon>
                    </v-btn>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-card-text>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span>{{ $t("Global.ForgotPassword.emailResetPasswordText") }}</span>
      <v-icon dark>check_circle</v-icon>
    </v-snackbar>
  </v-sheet>
</template>

<script>
export default {
  components: {
    SendOtp: () => import("./Partials/SendOtp"),
  },
  data() {
    return {
      snackbar: false,
      stepsDetails: [
        {
          title:  this.$t("Global.ForgotPassword.recoverAccountText") ,
          subtitle: this.$t("Global.ForgotPassword.emailResetPasswordText"),
          img: "/static/illustator/forgot_password.png",
        },
      ],
    };
  },
  methods: {
    completeProcess() {
      this.snackbar = true;
      this.$router.push({
        name: "Login",
      });
    },
  },
};
</script>
